import { useEffect, useState } from "react";
import Cookies from "js-cookie";

const useIsEvent = () => {
  const [isEvent, setIsEvent] = useState(false);

  useEffect(() => {
    const checkEventCookie = () => {
      const dataCookie = Cookies.get("dataEvent");
      if (dataCookie) {
        try {
          const data = JSON.parse(dataCookie);
          if (data && data.id) {
            setIsEvent(true);
            return;
          }
        } catch (e) {
          console.error("Invalid JSON in cookie:", e);
        }
      }
      setIsEvent(false);
    };

    checkEventCookie();

    const interval = setInterval(checkEventCookie, 1000);
    return () => clearInterval(interval);
  }, []);

  return [isEvent, setIsEvent];
};

export default useIsEvent;
